import _ from 'lodash';
import { GIT_PROVIDERS } from 'common/constants/constants';
import Icon from 'components/base/Icon';

export const mapGitProviderToIcon = {
  [GIT_PROVIDERS.GITHUB]: 'GithubIcon'
};

const SyncedIndicator = ({ gitProviderId, size = 'smaller' }) => {
  const icon = _.get(mapGitProviderToIcon, gitProviderId);
  if (!icon) return null;

  return <Icon name={icon} size={size} color='malachite' />;
};

export default SyncedIndicator;
